<template>
  <TransactionListTemplate
    :screenConfig="setScreenConfig"
    :rowClick="rowClickCallBack"
    :persistenceKey="'invoiced-order-list'"
    :setLoading="setLoading"
    :gcPopupConfig="gcPopupConfig"
    ref="invoiced-invoiced-list"
  />
</template>

<script>
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";
import { FeatureStorage } from "../../_services/storage";
import ColumnWidth from "@/_helpers/data-grid/ColumnWidth";

import TransactionListTemplate from "../../templates/transaction-list";
import {
  SalesOrderTabs,
  GetIndexByTabName,
} from "../../_models/tabdata/sales/salesorder-tabs";
import { CustomerInvoiceService } from "../../_services/api/customers/customer-invoice.service";

export default {
  props: {},
  mixins: [RouteMixin, FormMixin],
  components: {
    TransactionListTemplate,
  },
  data() {
    return {
      gcPopupVisible: false,
      newDueDateModel: {
        Code: undefined,
        CustomerName: undefined,
        SalesOrder: undefined,
        InvoiceDate: undefined,
        DueDate: undefined,
        NewDueDate: undefined,
        DateCreated: undefined,
      },
      NewDueDate: {
        Min: undefined,
        Max: undefined,
      },
      setLoading: false,
      AccountingPeriod: {
        StartDate: undefined,
        EndDate: undefined,
      },
    };
  },
  computed: {
    gcPopupConfig() {
      return {
        title: "Adjust Due Date",
        dataModel: this.newDueDateModel,
        callBack: this.gcPopupCallBack,
        gcPopupVisible: this.gcPopupVisible,
        height: 400,
        formOptions: {
          gcLabelLocation: "left",
        },
        items: [
          {
            screenField: "Invoice",
            dataField: "Code",
            label: {
              text: "Invoice #",
            },
          },
          {
            dataField: "CustomerName",
            label: {
              text: "Customer Name",
            },
          },
          {
            screenField: "SalesOrderCode",
            dataField: "SalesOrder",
            label: {
              text: "Sales Order",
            },
          },
          {
            screenField: "DateCreated",
            label: {
              text: "Invoice Date",
            },
          },
          {
            screenField: "DueDate",
            label: {
              text: "Current Due Date",
            },
          },
          {
            screenField: "DueDate",
            dataField: "NewDueDate",
            label: {
              text: "New Due Date",
            },
            editorOptions: {
              min: this.NewDueDate.Min,
              max: this.NewDueDate.Max,
              allowUpdate: true,
              onValueChanged: (e) => {
                if (e.event) this.onChangeNewDueDate(e);
              },
            },
          },
        ],
        save: {
          text: "Update",
          clickCallback: (e) => {
            this.onGcPopUpUpdate(e);
          },
          disabled:
            this.newDueDateModel.NewDueDate == this.newDueDateModel.DueDate
              ? true
              : false,
        },
        back: {
          text: "Cancel",
          clickCallback: () => {
            this.gcPopupCallBack();
          },
        },
      };
    },
    setScreenConfig() {
      var config = {
        title: "Sales Orders",
        ScreenName: "Sales Orders - Invoiced",
        selectedIndex: GetIndexByTabName("Invoiced"),
        tabs: SalesOrderTabs,
        exportFileName: "Invoiced Order List",
        gridData: {
          gridOptions: {
            dataSource: {
              endpoint: "InvoiceList",
              serverPaging: true,
              allowGrouping: false,
              select: [
                "Invoice",
                "SalesOrder",
                "CustomerCode",
                "CustomerName",
                "BillToCustomerCode",
                "BillToCustomerName",
                "BranchCode",
                "BranchDescription",
                "MarketCode",
                "AgentCode",
                "AgentName",
                "CustPO",
                "SalesRepresentativeCode",
                "SalesRepresentativeFullName",
                "DateIn",
                "DueDate",
                "DateCreated",
                "Total",
                "Balance",
                "TaxableTotal",
                "CustomerSalesRepresentativeCode",
                "CustomerSalesRepresentativeFullName",
                "CreditChipString",
                "InvoiceStatus",
                "DeliveryAddressCompanyName",
                "DeliveryNote",
                "InvoiceType",
                "ICFlag",
                "CurrencyCode",
                "IncTaxFXTotal",
                "FXBalance",
                "ExchangeRate",
              ],
            },
            noDataMessage: {
              addNew: {
                class: "add-new",
                title: "No Invoices, Credits",
                message: "Get Started, Add a Sales Order to Despatch",
              },
            },
            options: {
              selectionMode: "multiple",
            },
          },

          toolbar: {
            search: false,
            columnChooser: true,
            export: true,
            openFilter: true,
            expand: false,
            multiplePdf: true,
            screenName: "Sales Orders - Invoiced",
            customButtons: [
              {
                icon: "plus",
                label: "Add New",
                route: "/invoice/create",
                clickAction: {},
                buttonLocation: "left",
                visible: FeatureStorage.checkPermission("Invoice", "create"),
              },
            ],
          },
          columns: [
            {
              screenField: "Invoice",
              sortOrder: "desc",
              sortIndex: 0,
              allowHiding: false,
              fixed: true,
              fixedPosition: "left",
              filterIndex: 0,
              type: "Integer",
              width: ColumnWidth.Code.width,
              maxWidth: ColumnWidth.Code.minWidth,
            },
            {
              screenField: "DateIn",
              gridLabel: "Date",
              filterLabel: "Date",
              filterIndex: 10,
              width: ColumnWidth.Date.width,
              maxWidth: ColumnWidth.Date.minWidth,
            },
            {
              screenField: "Code",
              filterLabel: "Sales Order",
              filterDataField: "SalesOrder",
              showInColumnChooser: false,
              visible: false,
              type: "Integer",
              filterIndex: 1,
              width: ColumnWidth.Code.width,
              maxWidth: ColumnWidth.Code.minWidth,
            },
            {
              screenField: "Customer",
              filterIndex: 4,
            },
            {
              screenField: "BillToCustomer",
              visible: false,
              filterIndex: 5,
            },
            {
              screenField: "Branch",
              filterIndex: 7,
              visible: false,
            },
            {
              screenField: "Market",
              dataField: "MarketCode",
              filterDataField: "MarketCode",
              visible: false,
              filterIndex: 8,
            },
            {
              screenField: "Agent",
              filterDataField: "AgentCode",
              visible: false,
              filterIndex: 9,
            },
            {
              screenField: "CustPO",
              filterDataField: "CustPO",
              dataType: "string",
              type: "Text",
              filterIndex: 2,
              width: ColumnWidth.CustPO.width,
              maxWidth: ColumnWidth.CustPO.minWidth,
            },
            {
              screenField: "OrderRep",
              gridDataField: "SalesRepresentativeFullName",
              cellTemplateRecord: {
                primary: [
                  {
                    dataField: "SalesRepresentativeFullName",
                  },
                ],
                secondary: [
                  {
                    dataField: "SalesRepresentativeCode",
                  },
                ],
              },
              exportFields: [
                {
                  dataField: "SalesRepresentativeCode",
                  label: "Order Rep Code",
                },
                {
                  dataField: "SalesRepresentativeFullName",
                  label: "Order Rep Full Name",
                  allowSearch: false,
                },
              ],
              filterDataField: "SalesRepresentativeCode",
              filterIndex: 13,
              width: ColumnWidth.OrderRep.width,
              maxWidth: ColumnWidth.OrderRep.minWidth,
            },
            {
              screenField: "SalesOrder",
              width: ColumnWidth.Code.width,
              maxWidth: ColumnWidth.Code.minWidth,
            },
            {
              screenField: "CurrencyCode",
              width: ColumnWidth.CurrencyCode.width,
              maxWidth: ColumnWidth.CurrencyCode.minWidth,
            },
            {
              screenField: "DueDate",
              visible: false,
              filterIndex: 11,
              width: ColumnWidth.Date.width,
              maxWidth: ColumnWidth.Date.minWidth,
            },
            {
              screenField: "Total",
              gridLabel: "Total (Base Currency)",
              width: ColumnWidth.Price2DecimalPoints.width,
              maxWidth: ColumnWidth.Price2DecimalPoints.minWidth,
              visible: false,
            },
            {
              screenField: "Balance",
              gridLabel: "Balance (Base Currency)",
              width: ColumnWidth.Price2DecimalPoints.width,
              maxWidth: ColumnWidth.Price2DecimalPoints.minWidth,
              visible: false,
            },
            {
              screenField: "TaxableTotal",
              gridLabel: "Total Ex Tax (Base Currency)",
              width: ColumnWidth.Price2DecimalPoints.width,
              maxWidth: ColumnWidth.Price2DecimalPoints.minWidth,
              visible: false,
            },
            {
              screenField: "ExchangeRate",
              label: `FX Rate`,
              minWidth: ColumnWidth.ExchangeRate.minWidth,
              maxWidth: ColumnWidth.ExchangeRate.minWidth,
            },
            {
              screenField: "Total",
              gridLabel: "Total (FX)",
              gridDataField: "IncTaxFXTotal",
              width: ColumnWidth.Price2DecimalPoints.width,
              maxWidth: ColumnWidth.Price2DecimalPoints.minWidth,
            },
            {
              screenField: "FXBalance",
              dataField: "FXBalance",
              label: "Balance (FX)",
              width: ColumnWidth.Price2DecimalPoints.width,
              maxWidth: ColumnWidth.Price2DecimalPoints.minWidth,
            },
            {
              screenField: "CustomerRep",
              visible: false,
              filterIndex: 12,
            },
            {
              screenField: "OrderStatus",
              gridDataField: "CreditChipString",
            },
            {
              screenField: "InvoiceStatus",
              filterIndex: 3,
              dataSourceConfig: {
                data: [
                  "Allocated",
                  "Credited",
                  "Open",
                  "Overdue",
                  "Paid",
                  "Pending",
                ],
              },
            },
            {
              screenField: "DeliveryCompany",
              visible: false,
              gridLabel: "Delivery Company",
              filterIndex: 6,
              type: "Text",
              exportFields: undefined,
              cellTemplateRecord: {
                primary: [
                  {
                    dataField: "CompanyName",
                  },
                ],
              },
              dataSourceConfig: {
                endpoint: "api/CustomerDeliveryAddress",
                sort: {
                  selector: "LineNo",
                  asc: true,
                },
                filter: [["Inactive", "=", "N"]],
              },
              editorTemplate: {
                primary: [
                  {
                    dataField: "CompanyName",
                  },
                ],
              },
              valueExpr: "CompanyName",
              displayExpr: "CompanyName",
            },
            {
              screenField: "GridRecordEmail",
              cssClass: "padding-7",
              ReferenceNoFields: [
                {
                  ReportDisplayName: "Invoice",
                  ReferenceNoField: "Invoice",
                },
                {
                  ReportDisplayName: "Delivery Note",
                  ReferenceNoField: "DeliveryNote",
                },
              ],
            },
            {
              screenField: "GridRecordPDFView",
              cssClass: "padding-7",
              menuItems: {
                makeDisabled: (data) => {
                  var items = [];
                  var x = { ...data };

                  x.column.PrintPreview.forEach((element) => {
                    if (
                      (x.data.DeliveryNote == 0 &&
                        element.ScreenLayoutApplicationFeatureCode ===
                          "ReportDeliveryNote") ||
                      (x.data.InvoiceStatus == "Pending" &&
                        element.ScreenLayoutApplicationFeatureCode ===
                          "ReportInvoice")
                    )
                      element.disabled = true;
                    else element.disabled = false;

                    items.push({
                      ReportDisplayName: element.ReportDisplayName,
                      ScreenLayoutApplicationFeatureCode:
                        element.ScreenLayoutApplicationFeatureCode,
                      Parameters: element.Parameters,
                      disabled: element.disabled,
                    });
                  });

                  return items;
                },
              },
            },
            {
              screenField: "GridRecordPrint",
              cssClass: "padding-7",
              ReferenceNoFields: [
                {
                  ReportDisplayName: "Invoice",
                  ReferenceNoField: "Invoice",
                },
                {
                  ReportDisplayName: "Delivery Note",
                  ReferenceNoField: "DeliveryNote",
                },
              ],
              menuItems: {
                makeDisabled: (data) => {
                  var items = [];
                  var x = { ...data };

                  x.column.BackgroundPrint.forEach((element) => {
                    if (
                      (x.data.DeliveryNote == 0 &&
                        element.ReportDisplayName === "Delivery Note") ||
                      (x.data.InvoiceStatus == "Pending" &&
                        element.ReportDisplayName === "Invoice")
                    )
                      element.disabled = true;
                    else element.disabled = false;

                    items.push({
                      ReportDisplayName: element.ReportDisplayName,
                      TransactionCode: element.TransactionCode,
                      ScreenName: element.ScreenName,
                      disabled: element.disabled,
                    });
                  });

                  return items;
                },
              },
            },
            {
              screenField: "GridRecordEllipsisMenu",
              allowSearch: false,
              cssClass: "padding-7",
              ellipsisMenu: {
                itemAction: (data) => {
                  var items = [
                    {
                      menuText: "Adjust Due Date",
                      data: data,
                      clickAction: this.visibleGcPopUp,
                      disabled:
                        data.data.InvoiceStatus == "Paid" ||
                        data.data.InvoiceStatus == "Pending" ||
                        data.data.InvoiceStatus == "Credited" ||
                        !FeatureStorage.checkPermission("Invoice", "create")
                          ? true
                          : false,
                    },
                    {
                      menuText: "Credit",
                      data: data,
                      clickAction: this.goToCredit,
                      disabled:
                        data.data.InvoiceType == "Credit" ||
                        data.data.InvoiceStatus == "Pending" ||
                        !FeatureStorage.checkPermission("Invoice", "create") ||
                        data.data.InvoiceStatus == "Credited" ||
                        !data.data.SalesOrder,
                    },
                    {
                      menuText: "Receipt",
                      data: data,
                      clickAction: this.goToCreateCustomerReceipt,
                      disabled:
                        data.data.InvoiceStatus == "Paid" ||
                        data.data.InvoiceStatus == "Pending" ||
                        data.data.InvoiceStatus == "Credited" ||
                        !FeatureStorage.checkPermission(
                          "CashReceipt",
                          "create"
                        ),
                    },
                    {
                      menuText: "Edit",
                      data: data,
                      clickAction: this.goToEditInvoice,
                      disabled:
                        data.data.SalesOrder == 0 ||
                        data.data.InvoiceStatus == "Paid" ||
                        data.data.InvoiceStatus == "Pending" ||
                        data.data.InvoiceStatus == "Credited" ||
                        data.data.InvoiceType == "Credit" ||
                        !FeatureStorage.checkPermission("Invoice", "create") ||
                        !data.data.SalesOrder,
                    },
                  ];

                  return items;
                },
                keyExpr: "menuText",
                displayExpr: "menuText",
              },
              // makeDisabled: (data) => {
              // if (data.data.InvoiceStatus != "Paid")
              // return false;
              // else return true;
              // },
            },
          ],
        },
      };

      return config;
    },
  },
  methods: {
    gcPopupCallBack() {
      this.gcPopupVisible = false;
    },
    async onGcPopUpUpdate(e) {
      this.gcPopupCallBack();
      var payload = {
        Code: e.Code,
        DueDate: new Date(e.NewDueDate).toSaveDate(),
      };
      this.setLoading = true;
      await CustomerInvoiceService.saveCustomerInvoiceDueDate(payload)
        .then((res) => {
          if (res) this.setLoading = false;

          this.$notify(
            `Customer Invoice #${res.data.Code} Due Date Successfully Updated`,
            "success"
          );

          this.$refs["invoiced-invoiced-list"].$refs[
            "transactionListGrid"
          ].gridRepaint();
        })
        .catch((err) => {
          this.setLoading = false;
          this.serverError = {
            err: err,
            msg: "Update Failed.",
            time: new Date().getTime(),
          };
        });
    },

    rowClickCallBack(e) {
      if (
        e.rowType == "data" &&
        e.column.dataField != "InvoiceStatus" &&
        e.column.dataField != "CreditChipString" &&
        e.column.screenField != "GridRecordEmail" &&
        e.column.screenField != "GridRecordPDFView" &&
        e.column.screenField != "GridRecordPrint" &&
        e.column.screenField != "GridRecordEllipsisMenu" &&
        e.column.type != "selection"
      ) {
        if (e.data.InvoiceType == "Invoice" || e.data.ICFlag == "I") {
          this.onRowClicked(e, {
            view: this,
            page: "invoice",
            mode: "review",
            idProperty: "Invoice",
            query: {
              from: "/invoiced-order",
            },
          });
        } else {
          this.onRowClicked(e, {
            view: this,
            page: "credit-invoice",
            mode: "review",
            idProperty: "Invoice",
          });
        }
      }
    },
    goToCreateCustomerReceipt(e) {
      this.$router.push({
        path: `customer-receipt/create/${e.CustomerCode}`,
        query: {
          from: "invoice-order-list",
          invoiceNumber: e.Invoice,
        },
      });
    },
    goToEditInvoice(e) {
      this.$router.push({
        path: `invoice/edit/${e.Invoice}`,
        query: {
          from: "/invoiced-order",
          // invoiceNumber: e.Invoice,
        },
      });
    },
    goToCredit(e) {
      this.$router.push({
        path: `credit-invoice/create/${e.Invoice}`,
      });
    },
    onChangeNewDueDate(e) {
      this.newDueDate = e;
    },
    async visibleGcPopUp(data) {
      this.setLoading = true;

      this.newDueDateModel = {
        Code: data.Invoice,
        CustomerName: data.CustomerName,
        SalesOrder: data.SalesOrder,
        InvoiceDate: data.DateIn,
        DueDate: data.DueDate,
        NewDueDate: data.DueDate,
        DateCreated: data.DateCreated,
      };

      this.NewDueDate.Min = data.DateIn;

      this.setLoading = false;
      this.gcPopupVisible = true;
    },
  },

  created() {},
};
</script>

<style lang="scss"></style>
